import React from 'react';
import styles from './style/cardSet.module.css';

const CardSet = ({ children }) => {
  const count = React.Children.toArray(children);
  return (
    <div className={`
      ${styles.cardSet}
      ${count.length === 2 ? styles.cardSet_2 : ''}
      ${count.length === 3 ? styles.cardSet_3 : ''}
      ${count.length === 4 ? styles.cardSet_4 : ''}
      ${count.length === 5 ? styles.cardSet_5 : ''}
    `}
    >
      { children }
    </div>
  );
};

export default CardSet;
